export const drawerItemsMain = [
  {
    key: "ChinaTracker",
    title: "chinaTracker",
    routes: [
      {
        nav: "ChinaTrackerReport",
        routeName: "ChinaTrackerReport",
        title: "chinaTrackerReport",
      },
    ],
  },
  {
    key: "ChinaTrackerGantt",
    title: "chinaTrackerPlanning",
    routes: [
      {
        nav: "ChinaTrackerGanttReport",
        routeName: "ChinaTrackerGanttReport",
        title: "chinaTrackerPlanning",
      },
    ],
  },
  {
    key: "ChinaShipment",
    title: "chinaShipment",
    routes: [
      {
        nav: "ChinaShipmentReport",
        routeName: "ChinaShipmentReport",
        title: "chinaShipmentReport",
      },
    ],
  },
  {
    key: "GlobalShipment",
    title: "globalShipment",
    routes: [
      {
        nav: "GlobalShipmentReport",
        routeName: "GlobalShipmentReport",
        title: "globalShipmentReport",
      },
    ],
  },
];
